module.exports = __webpack_public_path__ + "b5ef2abd652f8dc8f21a51085a92974e.svg";